// extracted by mini-css-extract-plugin
module.exports =  {"button":"EditButton-EditButton-button-da9232ee","mobileButton":"EditButton-EditButton-mobileButton-c4da5f11"};